<!-- 
Dialog listing sandboxes.

Also allows creation, deletion and opening of levy collection sandboxes.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog md">
    <v-card>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>Levy collection sandboxes</v-toolbar-title>
      </v-toolbar>
      <v-alert :value="true" type="info" class="my-0">
        A sandbox is a copy of an existing levy collection that can be used to experiment with the effect of changing 
        risk factors, fees and rates. Because sandboxed levy collections will never send notices, generate invoices or talk to
        SAP, you can safely create and delete them as often as you want.
      </v-alert>
      <v-card-text>
        <sandbox-listing/>
        <v-alert :value="!canEdit" class="mt-0" type="warning">
          You will need to be assigned a role with the <i>levy collection - sandboxes</i> permission to use sandboxes.
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :disabled="busy" flat @click="hide">Close</v-btn>
      </v-card-actions>
    </v-card>
    <our-validation-dialog v-model="state.create.error.show" :state-error="state.create.error" />
  </v-dialog>
</template>

<script>
import * as claim from "@/store/claim-types";
import SandboxListing from "@/components/sandboxes/SandboxListing.vue";

export default {
  components: { SandboxListing },
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    state() {
      return this.$store.state.sandboxes;
    },
    busy() {
      return this.state.create.saving || this.state.delete.processing;
    },
    canEdit() {
      return this.$store.getters.claims.includes(claim.LEVY_COLLECTION_SANDBOXES);
    }
  },
  methods: {
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
